export default "__VITE_ASSET__BK_6uvqe__"